import { HeadFC, graphql } from 'gatsby'
import { Seo } from '@ndlib/component-library'
import { StructuredData } from '@ndlib/component-library'
import { useSiteMetadata } from '../../hooks/utils/useSiteMetadata'
import defaultImage from '../../images/News.Default.png'
import { useCheckPreviewMode } from '../../hooks/utils/useCheckPreviewMode'
import { NewsPreview } from '../../components/News/NewsPreview'
import { BaseNewsPage } from '../../components/News/BaseNewsPage'
import { useLocation } from '@reach/router'

export const query = graphql`
  query NewsArticle($slug: String!) {
    strapiNews(slug: { eq: $slug }) {
      slug
      title
      author
      publishedDate
      shortDescription
      content {
        data {
          content
        }
      }
      contactUsPubInfo {
        data {
          contactUsPubInfo
        }
      }
      image {
        url
      }
      video {
        videoDescription
        videoTitle
        videoUrl
      }
    }
  }
`

const NewsArticle: React.FC<{
  data: Queries.NewsArticleQuery
}> = ({ data }) => {
  const isPreview = useCheckPreviewMode()

  if (isPreview) {
    return (
      <NewsPreview slug={data?.strapiNews?.slug!} />
    )
  } else {
    return <BaseNewsPage data={data} />
  }
}

export default NewsArticle

export const Head: HeadFC = ({ data }) => {
  const location = useLocation()
  const news = []
  const makeArray = news.push(data.strapiNews)
  const seoDefaultData = useSiteMetadata()

  return (
    <>
      <html lang='en' />
      <meta name='description' content={data?.strapiNews?.shortDescription} />
      <Seo
        {...seoDefaultData}
        title={data.strapiNews.title}
        description={data?.strapiNews?.shortDescription}
        image={data?.strapiNews?.image?.url || defaultImage}
        pathname={location.href}
      />
      <StructuredData
        {...seoDefaultData}
        news={news}
        title={data.strapiNews.title}
        abstract={data?.strapiNews?.shortDescription}
        image={data?.strapiNews?.image?.url || defaultImage}
        pathname={location.href}
      />
    </>
  )
}
